import I18n from 'I18n';
import { COMPANY } from 'customer-data-objects/constants/ObjectTypes';
import { FlywheelDefaultCardAction } from '../default/FlywheelDefaultCardAction';
import { useFetchAssociations } from './useFetchAssociations';
import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const FlywheelDealCardAction = props => {
  const {
    canEditAssociation,
    fromObjectId,
    fromObjectTypeId
  } = props;
  const fromObjectType = denormalizeTypeId(fromObjectTypeId);
  const isOnCompanyRecord = fromObjectType === COMPANY;
  const companyAssociations = useFetchAssociations({
    fromObjectId,
    fromObjectType,
    toObjectType: COMPANY
  });
  const hasCompanyAssociaton = (companyAssociations || []).length > 0;
  // On records other than COMPANY, deals can only be associated if there is an existing company association
  const isEligibleForDealAssociation = isOnCompanyRecord || hasCompanyAssociaton;
  return /*#__PURE__*/_jsx(FlywheelDefaultCardAction, Object.assign({}, props, {
    canEditAssociation: canEditAssociation && isEligibleForDealAssociation,
    canEditAssociationMessageOverride: !isEligibleForDealAssociation ? I18n.text('flywheel.FlywheelDealCardAction.canEditAssociationMessageOverride') : undefined
  }));
};
export default FlywheelDealCardAction;